export type InstanceProfile = 'production' | 'staging' | 'development';

export interface InstanceBranding {
	displayName: string;
	profile: InstanceProfile;
	hasLogo: boolean;
	logoRevision: number | null;
}

export const INSTANCE_PROFILE_LABEL: Record<InstanceProfile, string> = {
	production: 'Production',
	staging: 'Test',
	development: 'Développement',
};

export function instanceEnvironmentNotice(
	profile: InstanceProfile
): string | null {
	if (profile === 'staging') return 'Environnement de test';
	if (profile === 'development') return 'Environnement de développement';
	return null;
}

export function instanceEnvironmentShort(
	profile: InstanceProfile
): string | null {
	if (profile === 'staging') return 'Test';
	if (profile === 'development') return 'Dev';
	return null;
}
